import React from "react";

const Clock = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_537_57)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.2C6.58818 2.2 2.20001 6.58817 2.20001 12C2.20001 17.4118 6.58818 21.8 12 21.8C17.4118 21.8 21.8 17.4118 21.8 12C21.8 6.58817 17.4118 2.2 12 2.2ZM3.80001 12C3.80001 7.47183 7.47184 3.8 12 3.8C16.5282 3.8 20.2 7.47183 20.2 12C20.2 16.5282 16.5282 20.2 12 20.2C7.47184 20.2 3.80001 16.5282 3.80001 12ZM12.8 6.61C12.8 6.16817 12.4418 5.81 12 5.81C11.5582 5.81 11.2 6.16817 11.2 6.61V11.78C11.2 12.0228 11.3103 12.2525 11.4998 12.4043L14.8198 15.0643C15.1646 15.3406 15.6681 15.285 15.9443 14.9402C16.2206 14.5954 16.165 14.0919 15.8202 13.8157L12.8 11.3959V6.61Z" fill="black" />
        </g>
        <defs>
            <clipPath id="clip0_537_57">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default Clock;
